import React, { FormEvent, useEffect, useState } from 'react'
import { Form } from 'react-router-dom';
import { Alert, Button, IconButton, InputLabel, TextField } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { IShipmentArap, IShipmentLight } from '../../types/shipment';

import { AppConfig } from '../../config/appConfig';

import { ShipmentService } from '../../services/shipmentService';

import Spinner from '../spinner';

import '../../styles/shipmentArapForm.scss';

export interface IShipmentArapForm {
	shipmentDetails: IShipmentLight;
	shipmentArap: IShipmentArap;
	isLoadingArap: boolean;
	onArapUpdated?: (arap: IShipmentArap) => void;
}

	const ShipmentArapForm: React.FunctionComponent<IShipmentArapForm> = ({ shipmentDetails, shipmentArap, isLoadingArap: isLoadingShipmentArap, onArapUpdated }) => {
	const [formFields, setFormFields] = useState<IShipmentArap>({ ...shipmentArap });
	const [isSaving, setIsSaving] = useState(false);
	const [successMessage, setSuccessMessage] = useState<string | undefined>();
	const [errorMessage, setErrorMessage] = useState<string | undefined>();
	const isShipmentComplete = () => shipmentDetails.status.toLowerCase() == "complete";

	const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		setErrorMessage(undefined);
		setIsSaving(true);

		ShipmentService.setArap(shipmentDetails.id, formFields)
			.then((response) => {
				console.log('ShipmentService.setArap: SUCCESS', response);
				onArapUpdated?.(response.data);
				setSuccessMessage("AR / AP information has been saved.");
				setTimeout(() => {
					setSuccessMessage(undefined);
				}, AppConfig.editSuccessToastMs);
			})
			.catch((error) => {
				console.log('ShipmentService.setArap: ERROR', error);
				setErrorMessage("We encountered an error while processing your request. Please try again.");
			})
			.finally(() => {
				setIsSaving(false);
			});
	}

	const handleInvoiceDateChange = (value: Dayjs | null) => {
		if (value) {
			let newFields = formFields;
			newFields.invoiceDate = value.toDate();
			setFormFields(newFields);
		}
	}

	return (
		<section className="hwi-shipment-arap-form">
			<Spinner dependency={isLoadingShipmentArap} text='Loading AR / AP information...'>
				<LocalizationProvider dateAdapter={AdapterDayjs}>
					{successMessage &&
						<Alert className="alert-success"
							severity="success"
							action={<IconButton onClick={() => { setSuccessMessage(undefined); }} size='small'>X</IconButton>}>
							{successMessage}
						</Alert>
					}
					{errorMessage &&
						<Alert className="alert-error"
							severity="error"
							action={<IconButton onClick={() => { setErrorMessage(undefined); }} size='small'>X</IconButton>}>
							{errorMessage}
						</Alert>
					}
					<Form onSubmit={(event) => handleSubmit(event)}>
						<div className="row">
							<InputLabel>Vendor Invoice Number</InputLabel>
							<TextField className="invoice-number-field" value={formFields.vendorInvoice} size="small" disabled={isShipmentComplete()} onChange={(event) => { setFormFields({ ...formFields, ["vendorInvoice"]: event.target.value }) }}></TextField>
						</div>
						<div className="row">
							<InputLabel>Transporter Invoice Number</InputLabel>
							<TextField className="invoice-number-field" value={formFields.transporterInvoice} size="small" disabled={isShipmentComplete()} onChange={(event) => { setFormFields({ ...formFields, ["transporterInvoice"]: event.target.value }) }}></TextField>
						</div>
						<div className="row">
							<InputLabel>Invoice Date</InputLabel>
							<DatePicker className="invoice-date-field" value={formFields.invoiceDate ? dayjs(formFields.invoiceDate) : null} disabled={isShipmentComplete()} onChange={(value) => handleInvoiceDateChange(value)} />
						</div>
						<div className="row">
							<InputLabel>Notes</InputLabel>
							<TextField multiline rows={4} className="invoice-notes-field" value={formFields.invoiceNotes} size="small" disabled={isShipmentComplete()} onChange={(event) => { setFormFields({ ...formFields, ["invoiceNotes"]: event.target.value }) }}></TextField>
						</div>
						{!isShipmentComplete() &&
							<div className="row controls">
								<Button type="submit" className="save-button" disabled={isSaving} variant="contained">{isSaving ? "Saving..." : "Save"}</Button>
							</div>
						}
					</Form>
					{/* <Json data={formFields}></Json> */}
				</LocalizationProvider>
			</Spinner>
		</section>
	)
}

export default ShipmentArapForm;